/* src/app/shared/components/alert/alert.component.scss */
.alert.alert-small {
  padding-right: 36px;
}
#alert-close-button {
  top: 50%;
  transform: translateY(-50%);
}
@media (max-width: 420px) {
  .alert {
    padding-top: 9px;
    padding-bottom: 9px;
  }
}
/*# sourceMappingURL=alert.component.css.map */
